// hooks
import { Fragment, useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHttp from "hooks/use-http";

// routes
import { useParams, useNavigate } from "react-router-dom";

// material styles
import { Grid, Button, TextField } from "@mui/material";

// material icons
import CheckIcon from "@mui/icons-material/Check";

// react icons
import { MdDelete } from "react-icons/md";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import BackButton from "components/shared/BackButton";
import DeleteModal from "components/shared/Modal/Delete";

// helper
import Toast from "helper/toast";

// styled component
import {
  StyledStack,
  StyledTitle,
  ButtonContainer,
} from "./editCategory.style";

// request methods
import {
  editEcudationCategoryRequest,
  deleteEducationCategoryByIdRequest,
  getEducationCategoryByIdRequest,
} from "api/requests/educations";

// validation
import { categorySchema } from "validations";

export default function EditEducationCategory() {
  const { education_category_id } = useParams();

  const navigate = useNavigate();

  const { request, loading, setLoading } = useHttp(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(categorySchema),
  });

  // show modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // show modal handler
  const handelShowModal = () => setShowDeleteModal((state) => !state);

  // delete education category
  const handleDeleteItem = useCallback(
    async (id) => {
      const res = await request({
        url: () => deleteEducationCategoryByIdRequest(id),
      });
      if (res) {
        Toast({ type: "success", title: "حذف سردسته آموزش " });
        handelShowModal();
        navigate("/education/category/add");
      } else {
        Toast({ type: "err", title: "حذف سردسته آموزش " });
        handelShowModal();
      }
    },
    [setLoading]
  );

  // get category data
  const getCategoryData = useCallback(async () => {
    setLoading(true);

    const res = await request({
      url: () => getEducationCategoryByIdRequest({ id: education_category_id }),
    });

    setLoading(false);
    if (res) {
      reset({
        title: res.data.title,
      });
    }
  }, [request]);

  // edit category
  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        editEcudationCategoryRequest({
          ...data,
          id: education_category_id,
        }),
    });

    if (res) {
      reset({
        title: "",
      });
      Toast({ type: "success", title: "ویرایش سردسته " });
      navigate("/education/category/add");
    }
    setLoading(false);
  };

  useEffect(() => {
    getCategoryData();
  }, [getCategoryData]);

  return (
    <DrawerCM title="ویرایش سردسته آموزش">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton Route="/education/category/add" />
            </Grid>
            <StyledStack>
              <Grid>
                <StyledTitle>ویرایش سردسته آموزش </StyledTitle>
                <Grid container>
                  <Grid item xs={12} p={1.5}>
                    <TextField
                      label="عنوان سردسته"
                      variant="outlined"
                      fullWidth
                      id="title"
                      {...register("title")}
                      error={Boolean(errors.title)}
                      helperText={errors.title?.message}
                    />
                  </Grid>
                  <ButtonContainer item xs={12}>
                    <Button
                      color="success"
                      startIcon={<CheckIcon />}
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      onClick={handleSubmit(onSubmit)}
                    >
                      ثبت
                    </Button>
                    <Button
                      color="error"
                      endIcon={<MdDelete />}
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handelShowModal();
                      }}
                    >
                      حذف
                    </Button>
                  </ButtonContainer>
                </Grid>
              </Grid>
            </StyledStack>
          </Grid>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={handleDeleteItem.bind(null, education_category_id)}
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
